module.exports = __webpack_public_path__ + "img/meeting_intro_2.af620e46.png";